<template>
<div :ref="cateobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑教程分类</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="catelist.length > 1 ? catelist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回版本管理</el-button>
        </div>
    </div>
    

    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in catelist" :key="index">
            <div class="TTL-form-submit-box-title">分类-{{index+1}}</div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">所属一级分类</label>
                    <wcselect 
                        :list="parentcatelist"
                        :value="item.pid > 0 ? item.pid : ''"
                        :option="{placeholder:'请选择一级分类',clearable:true,filterable:true,disabled:true,width:220,ischange:true}" 
                        @finish="(val)=> {
                            if(val.type=='change') catelist[index].pid=val.value
                        }"
                     />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">分类名称<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.name" placeholder="请输入账号名称" clearable />
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>


</div>
</template>

<script>
import INTERFACE_MODEL_PLAT_VEDIO from '@/Interface/Platsetting/PlatVedio';
export default {
    components:{},
    data() {
        return {
            cateobj:'platformvideocateedit',
            addlimit: 10,                              //单次新增限制
            cateinfo:{name:'',pid:''},                 //分类信息
            catelist:[],                               //分类列表
            parentcatelist:[],                         //一级分类信息大全
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetParentCate(); //获取一级分类信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前已有分类信息正在编辑，执行此操作会覆盖当前数据，是否执行 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetCateList(data.ids);
                }).catch(()=> {
                    
                });

            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.GetCateList(data.ids);
            } 
        },


        /** 提交数据 **/
        submitData() {
            //调整提交数据
            var data=[];
            for(var i=0;i<this.catelist.length;i++) data.push(this.catelist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs[this.cateobj];
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_PLAT_VEDIO.Edit_CATE({data:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.GoBackPets(true);
            });
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载
        
        /** 获取分类信息 **/
        GetCateList(ids) {
            //加载等待动画
            var loadingobj=this.$refs[this.cateobj];
            this.$loading.openloading(loadingobj);  
            INTERFACE_MODEL_PLAT_VEDIO.GET_CATE_INFO({ids:ids}).then((res) => {
                //关闭等待动画
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.catelist=res.data;
            });
        },


        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'使用教程分类',labelentry:'PlatFormVideoCate',components:'PlatFormVideoCate',isshow:false};
            var data={Method:''};
            if(isdellocal) data.delcomponents='EditPlatFormVideoCate';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 获取一级分类信息大全 **/
        GetParentCate() {
            this.$method.GET_PLAT_VEDIO_CATE_PARENT(true).then((res) => {
                this.parentcatelist=res;
                console.log(res)
            });
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.TTL-form-submit-box-title {margin-bottom:40px;}
</style>